<template>
    <div class="ChurchRecord">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-12">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ ChurchRecordData.Church.Name }}</span> </h1>
                    <h4><span>{{ ChurchRecordData.SubProgramMembership.SubProgram.Name }} </span><span>{{ formatDate(ChurchRecordData.SubProgramMembership.StartDate, 'MM/DD/YY') }}</span><span> - </span><span>{{ formatDate(ChurchRecordData.SubProgramMembership.EndDate, 'MM/DD/YY', 'Present') }}</span></h4>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div>
                        <div class="record-tabs">
                            <span class="d-none d-sm-block">
                                <b-nav tabs justified>
                                    <div v-for="pane in Panes">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                </b-nav>
                            </span>
                            <b-nav>
                                <span class="d-sm-none">
                                    <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                        <div v-for="pane in Panes">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                    </b-nav-item-dropdown>
                                </span>
                            </b-nav>
                        </div>
                        <div class="tab-content">
                            <div v-show="PaneShown == 'Summary'">
                                <ChurchSummary v-bind:church-record-data="ChurchRecordData" />
                            </div>
                            <div v-show="PaneShown == 'Church Info'">
                                <Information v-bind:church-record-data="ChurchRecordData" />
                            </div>
                            <div v-show="PaneShown == 'Region'">
                                <!--<Program v-bind:church-record-data="ChurchRecordData" />-->
                            </div>
                            <div v-show="PaneShown == 'People'">
                                <People v-bind:church-record-data="ChurchRecordData" />
                            </div>
                            <div v-show="PaneShown == 'Action Item'">
                                <ActionItem v-bind:church-record-data="ChurchRecordData" />
                            </div>
                            <!--<div v-show="PaneShown == 'Case File'">
            <CaseFile chart-type="Church"
                      :chart-record-id="ChurchRecordData.Church.Id" />
        </div>-->
                            <div v-show="PaneShown == 'Activity'">
                                <Interactions v-bind:church-record-data="ChurchRecordData" />
                            </div>
                            <!--<div v-show="PaneShown == 'New Document'">
            <NewDocument :form-memberships="SubProgramFormMemberships"
                         :chart-record-id="ChurchRecordData.Church.Id" />
        </div>-->
                            <!--<div v-show="PaneShown == 'Audit'">
             <Audit v-bind:child-record-data="ChildRecordData" />
        </div>-->
                            <div v-show="PaneShown == 'Admin'">
                                <Admin v-bind:church-record-data="ChurchRecordData" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Admin from "./Admin.vue";
    //import Audit from "./Audit.vue";
    import CaseFile from "../../../Core/RecordComponents/CaseFile.vue";
    import Information from "./Information.vue";
    import NewDocument from "../../../Core/RecordComponents/NewDocument.vue";
    import People from "./People.vue";
    import ActionItem from "./ActionItem.vue";
    //import Program from "./Program.vue";
    import ChurchSummary from "./Summary.vue";
    import Interactions from "./Interactions.vue";
    export default {
        props: [
            'ChurchRecordData'
        ],
        data: function () {
            return {
                PaneShown: "Summary",
                 Panes: [
                    { name: 'Summary' },
                    { name: 'Church Info' },
                    { name: 'People' },
                    { name: 'Action Item' },
                    { name: 'Activity' },
                    { name: 'Admin' }
                ],
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseChurchRecord(this.ChurchRecordData.Church.Id);
            }
        },
        components: {
            Admin,
            //Audit,
            CaseFile,
            Information,
            NewDocument,
            People,
            ActionItem,
            Interactions,
            //Program,
            ChurchSummary
        },
        mounted() {

        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
            SubProgramFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChurchRecordData.SubProgramMembership.SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "Church");
            }
        },
    }
</script>

<style scoped>
</style>